// src/stores/AuthStore.js (Pinia)
import { VIEW_MODES_TGU } from "@/types/Constants"
import { defineStore } from "pinia"

// The CompSetStore tracks the projects that a user has selected for comparison at the given time.
export const useMathSummaryStore = defineStore("MathSummaryStore", {
  id: 'mathSummaryStore',
  state: () => ({
    avgTotalGSF: null, // for reuse on chart
    avgTotalUnits : null,
    perProjectGSF: {},
    // viewModeDivisor changes based on view mode
    // View by total, divisor = 1
    // View by GSF, divisor = avg total GSF
    // View by Unit count, divisor = avg total unit count
    viewModeDivisor: 1,
    viewModeBy: VIEW_MODES_TGU.VIEW_BY_TOTAL,
    subjectPropertySqFt: null, // Store the subject property square feet
  }),
  getters: {
    getAvgTotalGSF: (state) => {
      return state.avgTotalGSF
    },
    getAvgTotalUnits: (state) => {
      return state.avgTotalUnits
    },
    getPerProjectGSF: (state) => {
      return state.perProjectGSF
    },
    getViewModeDivisor: (state) => {
      return state.viewModeDivisor
    },
    getViewModeBy: (state) => {
      return state.viewModeBy
    },
    getSubjectPropertySqFt: (state) => {
      return state.subjectPropertySqFt
    }
  },
  actions: {
    setAvgTotalGSF(avgTotalGSF) {
      this.avgTotalGSF = avgTotalGSF
    },
    setAvgTotalUnits(avgTotalUnits) {
      this.avgTotalUnits = avgTotalUnits
    },
    setPerProjectGSF(perProjectGSF) {
      this.perProjectGSF = perProjectGSF
    },
    setViewModeDivisor(viewModeDivisor) {
      this.viewModeDivisor = viewModeDivisor
    },
    setViewModeBy (value) {
      this.viewModeBy = value
    },
    setSubjectPropertySqFt(value) {
      this.subjectPropertySqFt = value
    }
  },
})
